import api from '@/api'

const store = {
  state: {
    dataMenuGroup: [],
    pagingMenuGroup: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingMenuGroup: {
      byField: '',
      isDesc: false
    },
    filteringMenuGroup: {
      outletCode: null,
      menuGroupCode: null,
      sequence: null
    }
  },

  mutations: {
    SET_MENUGROUP: (state, payload) => {
      state.dataMenuGroup = payload
    },
    SET_PAGING_PAGE_MENUGROUP: (state, payload) => {
      state.pagingMenuGroup.page = payload
    },
    SET_PAGING_TOTAL_MENUGROUP: (state, payload) => {
      state.pagingMenuGroup.total = payload
    },
    SET_SORTING_MENUGROUP: (state, payload) => {
      state.sortingMenuGroup = payload
    },
    SET_FILTERING_MENUGROUP: (state, payload) => {
      state.filteringMenuGroup = payload
    }
  },

  getters: {
    SortingMenuGroup: state => state.sortingMenuGroup,
    FilteringMenuGroup: state => state.filteringMenuGroup,
    PagingMenuGroup: state => state.pagingMenuGroup,
    GetAllMenuGroup: state => state.dataMenuGroup,
    GetOneMenuGroup: state => id =>
      state.dataMenuGroup.find(dataMenuGroup => dataMenuGroup.id === id)
  },

  actions: {
    async UpdateSortingMenuGroup({ commit, dispatch }, payload) {
      commit('SET_SORTING_MENUGROUP', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllMenuGroup')
    },

    async UpdateFilteringMenuGroup({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_MENUGROUP', emptyFilter)
      }
      commit('SET_PAGING_PAGE_MENUGROUP', 1)
      dispatch('GetAllMenuGroup')
    },

    async GetAllMenuGroup({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllMenuGroup(
          state.pagingMenuGroup,
          state.sortingMenuGroup,
          state.filteringMenuGroup
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_MENUGROUP', result.headers['data-length'])
        commit('SET_MENUGROUP', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateMenuGroup({ dispatch }, payload) {
      try {
        const { data } = await api.CreateMenuGroup(payload)
        dispatch('GetAllMenuGroup')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateMenuGroup({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateMenuGroup(payload.id, payload)
        dispatch('GetAllMenuGroup')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteMenuGroup({ dispatch }, id) {
      try {
        const { data } = await api.DeleteMenuGroup(id)
        dispatch('GetAllMenuGroup')
        return data
      } catch (e) {
        throw e
      }
    }
  }
}

export default store
